import { getUsersByIds } from './GetUsersByIds';
import { getInternalUsersByRole } from './GetInternalUsersByRole';
import { getChildOffices } from './GetChildOffices';

/**
 * Users Service
 * Provides business logic layer for users operations
 */
export const UsersService = {
  getUsersByIds,
  getInternalUsersByRole,
  getChildOffices,
};
